import React from "react";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact_us_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit saepe
        perspiciatis mollitia consectetur maxime fugit iure cupiditate quasi
        blanditiis magni ullam, necessitatibus officia incidunt, similique in.
        Deserunt quod assumenda eius.
      </h1>
    </div>
  );
};

export default ContactUs;
